@if (!loading && personal) {
  <app-breadcrumb
    listado="/main/emergencias/personalesSalud"
    etiquetaListado="Personal de salud"
    [titulo]="personal?.nombre"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas del detalle -->
  <header class="encabezado">
    <div class="encabezado-avatar">
      <mat-icon>{{ icono }}</mat-icon>
    </div>
    <div class="encabezado-texto">
      <h1>{{ personal.nombre || 'Personal de salud' }}</h1>
      @if (personal.rol) {
        <span class="encabezado-nombre">{{ personal.rol }}</span>
      }
      <div class="encabezado-chips">
        @if (personal.activo) {
          <span class="chip estado-ok">Activo</span>
        } @else {
          <span class="chip">Inactivo</span>
        }
        @if (cliente) {
          <span class="chip">
            <mat-icon>business</mat-icon>
            {{ cliente }}
          </span>
        }
      </div>
    </div>
    @if (puedeEditar) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar personal de salud"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <!-- Una sola vista: sin pestañas -->
  <div class="detalle-cuerpo">
    <div class="em-tarjetas">
      <app-dt-card titulo="Profesional" [icono]="icono">
        <app-dt-datos>
          <app-dt-dato
            etiqueta="Matrícula"
            [valor]="personal.matricula"
            mono
            copiable
          />
          <app-dt-dato etiqueta="DNI" [valor]="personal.dni" mono copiable />
          <app-dt-dato etiqueta="Fecha de alta" [valor]="fechaAlta" />
        </app-dt-datos>
      </app-dt-card>

      <app-dt-card titulo="Contacto" icono="contacts">
        <app-dt-datos>
          <app-dt-dato
            etiqueta="Teléfono"
            [valor]="personal.telefono"
            copiable
          />
          <app-dt-dato etiqueta="Email" [valor]="personal.email" copiable />
        </app-dt-datos>
      </app-dt-card>
    </div>
  </div>
} @else if (!loading) {
  <app-breadcrumb
    listado="/main/emergencias/personalesSalud"
    etiquetaListado="Personal de salud"
    [titulo]="personal?.nombre"
  ></app-breadcrumb>
  <app-empty-state
    icon="medical_services"
    message="No se encontró el profesional"
  ></app-empty-state>
} @else {
  <app-detalle-esqueleto
    [icono]="icono"
    listado="/main/emergencias/personalesSalud"
    etiquetaListado="Personal de salud"
    [pestanas]="0"
  ></app-detalle-esqueleto>
}
